import * as angular from 'angular';

class ReportDetailsRunHistoryController {
  currentRunToken: string;
  reportRunsCollection: any;
}

export const ID = 'reportDetailsRunHistory';

export const reportDetailsRunHistory: angular.IComponentOptions = {
  bindings: {
    reportRunsCollection: '<',
    currentRunToken: '<',
  },
  controller: ReportDetailsRunHistoryController,
  controllerAs: 'ctrl',
  template: `
    <div class="report-detail-run-history-container">
      <div class="report-detail-title">
        Run History
      </div>
      <run-history
        ng-if="ctrl.reportRunsCollection"
        runs-collection="ctrl.reportRunsCollection"
        current-run-token="{{ ctrl.currentRunToken }}">
      </run-history>
    </div>
  `,
};
